/*
 * noew scroll reveal — fade-up + stagger via IntersectionObserver.
 * Observes [data-noew-reveal] inside [data-noew-reveal-root]; reveals once.
 * Stagger groups ([data-noew-reveal-stagger]) get incremental --reveal-index.
 * Re-scans on shopify:section:load so it works in the theme editor.
 */
(function () {
  var REVEAL = '[data-noew-reveal]';
  var ROOT = '[data-noew-reveal-root]';
  var STAGGER = '[data-noew-reveal-stagger]';
  var STAGGER_CAP = 8;

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var supported = !reduceMotion && 'IntersectionObserver' in window;

  var observer = supported
    ? new IntersectionObserver(onIntersect, {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px',
      })
    : null;

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }

  // Assign incremental --reveal-index to each stagger group's items.
  function indexStaggerGroups(scope) {
    var groups = scope.querySelectorAll(STAGGER);
    Array.prototype.forEach.call(groups, function (group) {
      var selector = group.getAttribute('data-noew-reveal-stagger');
      var items = selector
        ? group.querySelectorAll(selector)
        : group.children;
      Array.prototype.forEach.call(items, function (item, i) {
        item.style.setProperty('--reveal-index', Math.min(i, STAGGER_CAP));
      });
    });
  }

  // Observe every reveal target inside an enabled root within `scope`.
  function scan(scope) {
    var roots = scope.querySelectorAll(ROOT);
    Array.prototype.forEach.call(roots, function (root) {
      indexStaggerGroups(root);
      var targets = root.querySelectorAll(REVEAL);
      Array.prototype.forEach.call(targets, function (target) {
        if (target.classList.contains('is-revealed')) return;
        if (!observer) {
          target.classList.add('is-revealed'); // reduced motion / no IO
          return;
        }
        observer.observe(target);
      });
    });
  }

  function init() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-scan a section when it is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) scan(e.target);
  });
})();
